import React from 'react';
import PropTypes from 'prop-types';
import { FocusRing } from '@react-aria/focus';
import Dropdown from '../../../Dropdown/Dropdown';


const AttributeForm = function AttributeFormComponent({
  formValues,
  selectAttribute,
  submitAttribute,
  filteringAttributes,
}) {
  return (
    <div className="attribute-selector-form__container">
      {filteringAttributes.map(({ filter, options, label }) => {
        const selectedValue = formValues[filter].value;

        return options.length > 1 && (
          <div className="attribute-selector__dropdown-container" key={filter}>
            <div id="attribute-selector-form__field-label" className="attribute-selector-form__field-label">{label}</div>
            <Dropdown
              options={options}
              fieldName={filter}
              theme="commoditySwitcher"
              onChange={selectAttribute}
              selectedValue={selectedValue}
              inputDescribedBy="attribute-selector-form__field-label"
            />
          </div>
        );
      })}
      <FocusRing focusRingClass="attribute-selector-form__button--focused">
        <button className="attribute-selector-form__button" type="button" onClick={submitAttribute}>
          Update
        </button>
      </FocusRing>
      <div className="attribute-selector-form__disclaimer">
        Updating your service type will change instant rebates, offers and amounts shown throughout the site. You can update it at any time throughout the shopping experience. If you are unsure, your service type will be confirmed during the eligibility check.
      </div>
    </div>
  );
};

AttributeForm.propTypes = {
  formValues: PropTypes.shape({}).isRequired,
  selectAttribute: PropTypes.func.isRequired,
  submitAttribute: PropTypes.func.isRequired,
  filteringAttributes: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      filter: PropTypes.string.isRequired,
      options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      })).isRequired,
    }),
  ).isRequired,
};

export default AttributeForm;
